
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/my-rewards",
      function () {
        return require("private-next-pages/account/my-rewards/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/my-rewards"])
      });
    }
  